module.exports = __webpack_public_path__ + "img/thumb_21.9c40455d.jpg";